import { Button, Flex } from "antd";
import { Popup } from "../../components";
import { usePopup } from "../../hooks/usePopup";
import { FilterIcon } from "../../assets";
import FilterForm from "../../forms/FilterForm";
import AppliedFilter from "../../forms/AppliedFilter";
import ATCExamTable from "./ATCExamTable";

export default function ATCExam() {
  const filterFormPopup = usePopup();
  return (
    <>
      <Flex gap="large" wrap>
        <Popup
          ref={filterFormPopup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm popup={filterFormPopup} />
        </Popup>
        <AppliedFilter />
      </Flex>
      <ATCExamTable />
    </>
  );
}
